<template>
	<div>
		<!-- For Sharing the Profile -->
		<div
			v-if="showtstdiv"
			class="primary-toast d-flex align-items-center p-2 mt-2"
		>
			<div>
				<img src="../../assets/New Profile/primary-rule.svg" alt="" />
			</div>
			<div class="d-flex ml-2 primary-toast-text">
				You can only share your Primary Profile
			</div>
		</div>
		<div
			class="sharelink-box tabs-dash-sharebox"
			:class="customClass"
			v-else-if="shareClicks && !userinfo.isDisabled && isPrimary"
			ref="myexpdropdown"
		>
			<div class="candash-displaytxt-grey-2 d-flex justify-content-between">
				Copy link to share
				<div v-if="linkCopied">
					<img
						src="../../assets/newdesign/dashboard/greyTick.svg"
						class="mr-1"
					/>
					<span class="copied-link">Copied</span>
				</div>
			</div>
			<div class="mt-2 position-relative">
				<b-form-input
					id="test-link"
					class="sharelink-input"
					v-model="candidateInfo.link"
					disabled
				>
				</b-form-input>
				<img
					@click.stop="copyTheLink(candidateInfo.link)"
					class="copy-position pointer"
					src="../../assets/newdesign/dashboard/copyBlue.svg"
					alt=""
				/>
			</div>
			<!-- <div v-if="linkCopied">LinkCopied</div> -->
			<div class="d-flex align-items-center mt-2">
				<div ref="qrCodeContainer" class="qr-code-container mr-2">
					<img class="h-100 w-100" :src="candidateInfo.qrCode" alt="" />
				</div>
				<div class="candash-displaytxt-grey-3">
					Download and share profile QR
				</div>
				<div>
					<img
						@click.stop="downloadQRCode"
						class="ml-2 pointer"
						src="../../assets/newdesign/dashboard/download2.svg"
						alt=""
					/>
				</div>
			</div>
		</div>
		<div
			v-else-if="shareClicks && userinfo.isDisabled && isPrimary"
			class="sharelink-box"
			:class="customClass"
		>
			<div class="d-flex align-items-center mb-resume-name">
				<img
					class="mr-2"
					src="../../assets/newdesign/dashboard/accountDis.svg"
					alt=""
				/>Your Account is Disabled
			</div>
			<div class="light-black-new-txt mt-2 ml-2">
				Your Hire3x account is disabled and cannot access the share profile
				feature.
			</div>
			<div class="light-black-new-txt-2 mt-1 ml-2">
				Enable your Account now to get full access to the activities.
			</div>
			<div class="d-flex justify-content-center mt-4">
				<b-button @click="enableProfile" class="candash-addBtn-sm"
					>Enable Account</b-button
				>
			</div>
		</div>
	</div>
</template>
<script>
import { enableProfile } from "@/utils/apiFunctions";
import toast from "../mixin/toast";
import capacitorDownload from "@/components/mixin/capacitorDownload";
import { mapGetters } from "vuex";

export default {
	name: "",
	components: {},
	mixins: [toast, capacitorDownload],
	props: {
		showtstdiv: Boolean,
		shareClick: Boolean,
		isPrimary: Boolean,
		candidateInfo: Object,
		customClass: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			shareClicks: false,
			linkCopied: false,
		};
	},
	computed: {
		...mapGetters("userVUEX", {
			userinfo: "getUserInfo",
		}),
	},
	watch: {},
	created() {
		this.shareClicks = this.shareClick;
		if (!this.shareClick) {
			this.linkCopied = false;
		}
	},
	mounted() {},
	methods: {
		closeShare() {
			this.linkCopied = false;
			this.$emit("close");
		},
		copyTheLink(sharedLink) {
			this.$copyToClipboard(sharedLink);
			this.linkCopied = true;
		},
		async downloadQRCode() {
			await this.downloadResumeFile(this.candidateInfo.qrCode, "qr_code.png");
		},
		async enableProfile() {
			let payload = {
				isDisabled: false,
			};
			const res = await enableProfile(payload);
			if (res.status == 200) {
				this.successModal(
					"Success",
					"Your account has been enabled successfully."
				);
				this.$store.commit("userVUEX/setUserInfoisDisabled", false);
				this.userInfo.isDisabled = false;
				this.closeShare();
			}
		},
	},
};
</script>
<style lang="" scoped></style>
